import React from 'react';
import { twMerge } from 'tailwind-merge';

export function FooterButtonContainer(props: { children: React.ReactNode; className?: string }) {
	return <div className={twMerge('flex space-x-2 justify-end', props.className)}>{props.children}</div>;
}
